import { render, staticRenderFns } from "./SelectPurchaser.vue?vue&type=template&id=cc84fdd2&scoped=true"
import script from "./SelectPurchaser.vue?vue&type=script&lang=js"
export * from "./SelectPurchaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc84fdd2",
  null
  
)

export default component.exports